export default function config() {
    return {
        apiUrl: 'https://api.whereismybrand.com.mx/api',
        //apiUrl: 'http://127.0.0.1:1337/api',
        assetUrl: 'https://api.whereismybrand.com.mx',
        baseUrl: 'https://whereismybrand.com.mx'
    }
}